import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import { Grid, MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../../components/select/filterSelect";
import CardChat from "../../../../components/card/CardChat";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../../components/input/inputTextField";
import { useDispatch, useSelector } from "react-redux";
import { advisorTypeApi } from "../../../../api/advisor-type/advisor-type.api";
import { advisorApi } from "../../../../api/advisor/advisor.api";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import { unsetLoading } from "../../../../store/loading/loading.slice";
import { advisorStudentApi } from "../../../../api/advisor-student/advisor-student.api";
import { alertError, alertSuccess } from "../../../../components/alert/swal";
import { dataEvaluation } from "../../../../utils/usage_form_evluation";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../../utils/statusRequest";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import ImageTracking from "../../../../components/upload/MultiUploadFile";
import { colors } from "../../../../constants/colors";
import VotingEvaluation from "../../reports/VotingEvaluationReport";
import { useTranslation } from "react-i18next";

const ManageStudentConsultation = () => {
  const { t, i18n } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const grade_level = queryParams.get("grade_level");
  const faculty_name = queryParams.get("faculty_name");

  const [inputValue, setInputValue] = useState({
    selected_usage_type: "",
    selected_advisor_type: 0,
    selected_advisor_type_name: "",
    selected_advisor_id: 0,
    selected_employee_id: 0,
    selected_faculty_id: 0,
    detail: "",
    new_message: "",
    //
    status: "",
    last_updated_by: "",
  });

  const [singleData, setSingleData] = useState<any>({});
  const [singleDataStudent, setSingleDataStudent] = useState<any>({});

  const [chatDetail, setChatDetail] = useState<any[]>([]);

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [isNewRequest, setIsNewRequest] = useState(false);

  const [imageConsult, setImageConsult] = useState<any[]>([]);

  const handleChangeImageConsult = (newFile: any) => {
    const newArray = Array.isArray(newFile) ? newFile : [newFile];
    if (newFile?.length > 0) {
      setImageConsult([...imageConsult, ...newArray]);
    } else {
      setImageConsult([...imageConsult, newFile]);
    }
  };
  const handleDeleteImageConsult = (index_file: number) => {
    setImageConsult((prev) => prev.filter((_, i: number) => i !== index_file));
  };

  const [faculty, setFaculty] = useState<any[]>([]);

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  const getDataAdvisor = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getFaculty = async () => {
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setFaculty(data.data);
      } else {
        setFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  useEffect(() => {
    getAdvisorType();
    getDataAdvisor();
    getDataEmployee();
    getFaculty();
  }, []);

  const [term, set_term] = useState<number | null>(null);
  const getSingleDataConsultation = async (id: number) => {
    const res = await advisorStudentApi.getAdvisorStudentById(id);
    const data = res.data;
    if (data.status < 300) {
      set_term(data?.data?.student?.term || null);
      let parsedAdvisorStudentDetail = {} as any;


      try {
        parsedAdvisorStudentDetail = JSON.parse(
          data?.data.advisor_student_detaill
        );
      } catch (error) {
        console.error("Error parsing advisor_student_detaill:", error);
      }

      setSingleDataStudent(data.data?.student);

      setInputValue({
        selected_usage_type: data.data?.advisor_group ?? "-",
        selected_advisor_type: parsedAdvisorStudentDetail?.advisor_type ?? 0,
        selected_advisor_type_name:
          parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
        selected_advisor_id: data.data?.id_advisor ?? "-",
        selected_employee_id: data.data?.id_employee ?? "-",
        selected_faculty_id: parsedAdvisorStudentDetail.faculty_id ?? "-",
        detail: parsedAdvisorStudentDetail.detail ?? "-",
        new_message: "",
        status: parsedAdvisorStudentDetail.status ?? "",
        last_updated_by: parsedAdvisorStudentDetail.last_updated_by ?? "",
      });
      setSingleData(parsedAdvisorStudentDetail);

      const fileData = data.data.advisorStudentFile ?? [];
      const chatData = parsedAdvisorStudentDetail.chat;

      const mergedData = [
        // Map chat data
        ...chatData.map((chat: any) => ({
          chat_id: chat.chat_id,
          chat_type: chat.chat_type,
          message: chat.message,
          send_date: chat.send_date,
          send_by: chat.send_by,
          send_to: chat.send_to,
          content_type: "text",
          file: null,
        })),
        // Map file data
        ...fileData.map((file: any) => ({
          chat_id: file.id_advisor_student_file,
          chat_type: "file",
          message: null,
          send_date: file.created_date,
          send_by: file.created_id,
          send_to: null, // Use the same `send_to` as chat
          content_type: "file",
          file,
        })),
      ];

      const uniqueMergedData = mergedData.reduce((acc, item) => {
        // Check if the chat_id already exists in the accumulator
        if (
          !acc.some(
            (existingItem: any) => existingItem.chat_id === item.chat_id
          )
        ) {
          acc.push(item); // Add item if it's not a duplicate
        }
        return acc;
      }, []);

      setChatDetail(uniqueMergedData ?? []);
    } else {
      setInputValue({
        selected_usage_type: "",
        selected_advisor_type: 0,
        selected_advisor_type_name: "",
        selected_advisor_id: 0,
        selected_employee_id: 0,
        selected_faculty_id: 0,
        detail: "",
        new_message: "",
        status: "",
        last_updated_by: "",
      });
      setSingleData({});
      setChatDetail([]);
    }
  };

  useEffect(() => {
    if (id) {
      getSingleDataConsultation(+id);
    }
  }, [id]);

  const handleUploadFile = async (consult_id?: number, newFile?: any) => {
    if (newFile && newFile.length > 0 && consult_id) {
      let formData = new FormData();

      for (let i = 0; i < newFile.length; i++) {
        formData.append("files", newFile[i].file); // "files" should match your backend field name
      }

      try {
        dispatch(unsetLoading());
        const response = await advisorStudentApi.updloadConsultFile(
          consult_id,
          formData
        );
        if (response.status < 300) {
          alertSuccess(
            t("ตอบกลับคำปรึกษา"),
            t("ตอบกลับคำปรึกษา เรียบร้อยแล้ว"),
            undefined,
            () => {
              getSingleDataConsultation(+consult_id);
              setIsNewRequest(false);
              setImageConsult([]);
            }
          );
        }
      } catch (error) {
        alertError(t("ตอบกลับ ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  const handleSave = async (
    id: number,
    prevData: any,
    prevChat: any,
    body: any
  ) => {
    if (profile && id && body.new_message !== "") {
      try {
        dispatch(unsetLoading());

        const filteredChat = (prevChat ?? []).filter((chat: any) => {
          if (chat.file) {
            // Compare chat_id with id_advisor_student_file
            return chat.chat_id !== chat.file.id_advisor_student_file;
          }
          return true; // If no file, keep the chat
        });

        const bodyJson = {
          ...prevData,
          last_updated_by:
            profile && profile.user_type === "student" ? "student" : "advisor",
          status: "response",
          chat: [
            ...(filteredChat ?? []),
            {
              chat_id: new Date().getTime(),
              chat_type:
                profile && profile.user_type === "student"
                  ? "student"
                  : "advisor",
              message: body.new_message,
              send_date: new Date(),
              send_by: (profile && profile.id_user) ?? 0,
              send_to:
                profile && profile.user_type === "student"
                  ? body.selected_employee_id
                  : 0,
            },
          ],
        };

        const newBody = {
          advisor_student_detaill: JSON.stringify(bodyJson),
        };

        const response = await advisorStudentApi.updateAdvisorStudent(
          +id,
          newBody
        );
        // if (response.status < 300) {
        //   alertSuccess(
        //     "ส่งเรื่องขอคำปรึกษา",
        //     "ส่งเรื่องขอคำปรึกษา เรียบร้อยแล้ว",
        //     undefined,
        //     () => {
        //       getSingleDataConsultation(+id);
        //       setIsNewRequest(false);
        //     }
        //   );
        // }
        if (response.status < 300) {
          if (imageConsult.length > 0) {
            handleUploadFile(+id, imageConsult);
          } else {
            alertSuccess(
              t("ส่งเรื่องขอคำปรึกษา"),
              t("ส่งเรื่องขอคำปรึกษา เรียบร้อยแล้ว"),
              undefined,
              () => {
                getSingleDataConsultation(+id);
                setIsNewRequest(false);
              }
            );
          }
        }
      } catch (error) {
        alertError(t("ส่งเรื่องขอคำปรึกษา ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    } else {
      alertError(t("ข้อมูลไม่ครบถ้วน"));
    }
  };

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("อาจารย์ที่ปรึกษา"),
            key: "1",
            pathName: routeName.advisor.manageAdvisorRequest,
          },
          {
            name: t("ส่งเรื่องขอคำปรึกษา"),
            key: "2",
            pathName: routeName.advisor.studentConsultation + "/" + id,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {t("ส่งเรื่องขอคำปรึกษา")}{" "}
          <CustomStatus
            label={handleColorStatusConsultRequestUtil(
              inputValue?.status,
              profile && profile.user_type
            )}
            type="outlined"
            color={handleTextStatusConsultRequestUtil(inputValue?.status)}
            icon={<FiberManualRecord />}
            width="250px"
          />
        </Typography>
      </section>

      <Grid container spacing={2} alignItems="starts">
        <Grid item xs={12} sm={3.5}>
          <Typography variant="subtitle1">
            {t("ชื่อ - นามสกุล :")}{" "}
            {(singleDataStudent &&
              singleDataStudent.student_frist_name +
              " " +
              singleDataStudent.student_last_name) ??
              ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            {t("ฉายา :")}{" "}
            {(singleDataStudent && singleDataStudent.student_middle_name) ?? ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle1">
            {t("รหัสประจำตัวนักศึกษา :")}{" "}
            {(singleDataStudent && singleDataStudent.student_no) ?? ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Typography variant="subtitle1">{t("ชั้นปีที่ :")}{term || "-"}</Typography>
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <Typography variant="subtitle1">{t("หลักสูตร :")} {faculty_name}</Typography>
        </Grid>
      </Grid>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={t("เลือกประเภท")}
            value={inputValue.selected_usage_type ?? ""}
            labelId="type-id"
            selectId="type-select-id"
            options={[
              {
                id_type: "",
                type_name: t("เลือกประเภท"),
              },
              ...dataEvaluation.map((list) => ({
                id_type: list.id,
                type_name: list.name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_type} key={index + 1}>
                {t(list.type_name)}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValue("selected_usage_type", e.target.value)
            }
            disabled
          />
        </article>

        {inputValue &&
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำชั้น" && ( // i18n-ignore
            <>
              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <FilterSelect
                  heading={t("ประเภทคำปรึกษา")}
                  value={inputValue.selected_advisor_type ?? ""}
                  labelId="type-id"
                  selectId="type-select-id"
                  options={[
                    {
                      id_type: "0",
                      type_name: t("ประเภทคำปรึกษา"),
                    },
                    ...dataAdvisorType.map((list) => ({
                      id_type: list.id_advisor_type,
                      type_name: list.advisor_type_name,
                    })),
                  ].map((list, index) => (
                    <MenuItem value={list.id_type} key={index + 1}>
                      {list.type_name}
                    </MenuItem>
                  ))}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setInputValue({
                      ...inputValue,
                      selected_advisor_type: +e.target.value,
                    });
                    setInputValue({
                      ...inputValue,
                      selected_advisor_type_name:
                        dataAdvisorType.find(
                          (list) => list.id_advisor_type === e.target.value
                        ).advisor_type_name || "",
                    });
                  }}
                  disabled
                />
              </article>
            </>
          )}

        {inputValue &&
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำรายวิชา" && ( // i18n-ignore
            <>
              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12"></article>

              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <AutocompleteSelect
                  heading={t("รายวิชา")}
                  freeSolo
                  labelId={"-"}
                  options={faculty ?? []}
                  value={
                    faculty.find(
                      (x: any) =>
                        x?.id_faculty === inputValue.selected_faculty_id
                    ) || null
                  }
                  getOptionLabel={(option: any) =>
                    `${i18n.language === "en" ? option?.faculty_name_eng || option?.faculty_name : option?.faculty_name}` || ""
                  }
                  renderOption={(props, option) => (
                    <li {...props}>{`${i18n.language === "en" ? option?.faculty_name_eng || option?.faculty_name : option?.faculty_name}`}</li>
                  )}
                  // value={inputValue.adv_employee_id ?? null}
                  disabled
                />
              </article>
            </>
          )}

        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
          <CardChat
            data={
              (chatDetail &&
                chatDetail?.map((item: any, index: number) => ({
                  id: item.chat_id,
                  type:
                    item.chat_type === "student"
                      ? t("นักศึกษา")
                      : t("อาจารย์ที่ปรึกษา"),
                  sender:
                    profile && profile.id_user === item.send_by ? "me" : "you",
                  message: item.message,
                  date: item.send_date,
                  content_type: item.content_type,
                  file: item.file,
                }))) ??
              []
            }
          />
        </article>

        {inputValue && inputValue?.status !== "success" && (
          <>
            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
              <InputTextField
                heading={t("รายละเอียด")}
                placeholder={t("ระบุรายละเอียด")}
                value={inputValue.new_message}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValue("new_message", e.target.value)
                }
                row={3}
                maxRows={5}
                disablePaddingMultiline
                multiline
                inputHeight={"auto"}
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
              <ImageTracking
                disabled={false}
                required
                headingVariant="h6"
                sxHeading={{ color: colors.themeMainColor }}
                heading={t("แนบรูปภาพ")}
                handleDeleteImageApi={() => { }}
                handleDeleteImageSelect={(_, index: number) =>
                  handleDeleteImageConsult(index)
                }
                onChange={handleChangeImageConsult}
                tabIndex={0}
                valueAddFile={imageConsult}
                valueImage={[]}
              />
            </article>
          </>
        )}
      </div>

      {inputValue && inputValue?.status === "success" && (
        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
          <VotingEvaluation id={id ? +id : 0} />
        </article>
      )}

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <>
          <ButtonOutlined
            onClick={() => {
              navigate(routeName.advisor.manageAdvisorRequest);
            }}
            mode="del"
            buttonName={t("ยกเลิก")}
            btnProps={{
              width: "200px",
              margin: "12px",
            }}
          />
          {inputValue && inputValue?.status !== "success" && (
            <ButtonPrimary
              onClick={() => {
                if (id) {
                  handleSave(+id, singleData, chatDetail, inputValue);
                }
              }}
              mode="next"
              buttonName={t("ยืนยัน")}
              btnProps={{
                width: "200px",
                margin: "12px",
              }}
            />
          )}
        </>
      </section>
    </div>
  );
};

export default ManageStudentConsultation;
